export default {
  // 页面标题和导航
  'pages.other-fee.title': '其他费用',
  'pages.other-fee.subtitle': '管理小区其他费用账单的生成、缴费和查询',
  'pages.other-fee.currentSelection': '当前选择：',
  'pages.other-fee.tabOther': '其他',
  'pages.other-fee.treeTitle': '楼栋楼层房屋选择',
  'pages.other-fee.breadcrumb.chargeManagement': '收费管理',
  'pages.other-fee.breadcrumb.otherFee': '其他费用',

  // 表格相关
  'pages.other-fee.table.title': '其他费用账单列表',
  'pages.other-fee.table.houseInfo': '房屋信息',
  'pages.other-fee.table.period': '账期',
  'pages.other-fee.table.billNo': '账单编号',
  'pages.other-fee.table.billName': '账单名称',
  'pages.other-fee.table.ownerPhone': '业主手机',
  'pages.other-fee.table.ownerIdCard': '业主身份证',
  'pages.other-fee.table.ownerEmail': '业主邮箱',
  'pages.other-fee.table.finalAmount': '最终应付金额',
  'pages.other-fee.table.approvalStatus': '审核状态',
  'pages.other-fee.table.status': '缴费状态',
  'pages.other-fee.table.paidDate': '缴费时间',
  'pages.other-fee.table.endTime': '到期日期',
  'pages.other-fee.table.operation': '操作',
  'pages.other-fee.table.view': '查看',
  'pages.other-fee.table.edit': '编辑',
  'pages.other-fee.table.delete': '删除',

  // 操作按钮
  'pages.other-fee.action.add': '新建账单',
  'pages.other-fee.action.submitAudit': '提交审核',
  'pages.other-fee.action.batchDelete': '批量删除',
  'pages.other-fee.action.update': '更新',
  'pages.other-fee.action.create': '创建',
  'pages.other-fee.action.cancel': '取消',
  'pages.other-fee.action.close': '关闭',

  // 确认对话框
  'pages.other-fee.confirm.delete.title': '确认删除',
  'pages.other-fee.confirm.delete.content': '确定要删除选中的 {count} 条记录吗？',
  'pages.other-fee.confirm.delete.okText': '确定',
  'pages.other-fee.confirm.delete.cancelText': '取消',

  // 审核相关
  'pages.other-fee.audit.modalTitle': '提交审核',
  'pages.other-fee.audit.auditName': '审核名称',
  'pages.other-fee.audit.auditNamePlaceholder': '请输入审核名称',
  'pages.other-fee.audit.submitRemark': '提交说明',
  'pages.other-fee.audit.submitRemarkPlaceholder': '请输入提交说明（可选）',
  'pages.other-fee.audit.selectedBillsTitle': '选中的账单列表（共 {count} 条）',
  'pages.other-fee.audit.totalAmount': '总金额',
  'pages.other-fee.audit.submit': '提交审核',
  'pages.other-fee.audit.defaultName': '{period} 其他费用账单 ({count}笔)',

  // 表单相关
  'pages.other-fee.form.editTitle': '编辑其他费用账单',
  'pages.other-fee.form.createTitle': '新建其他费用账单',
  'pages.other-fee.form.basicInfo': '基本信息',
  'pages.other-fee.form.houseOwnerInfo': '房屋与业主信息',
  'pages.other-fee.form.feeInfo': '费用信息',
  'pages.other-fee.form.remarkInfo': '备注信息',

  // 表单字段
  'pages.other-fee.form.billNo': '账单编号',
  'pages.other-fee.form.billNoPlaceholder': '请输入账单编号',
  'pages.other-fee.form.billNoRequired': '请输入账单编号',

  'pages.other-fee.form.billName': '账单名称',
  'pages.other-fee.form.billNamePlaceholder': '请输入账单名称',
  'pages.other-fee.form.billNameRequired': '请输入账单名称',

  'pages.other-fee.form.status': '缴费状态',
  'pages.other-fee.form.statusPlaceholder': '请选择缴费状态',
  'pages.other-fee.form.statusRequired': '请选择缴费状态',

  'pages.other-fee.form.period': '账期',
  'pages.other-fee.form.periodPlaceholder': '如：2024-01',
  'pages.other-fee.form.periodRequired': '请输入账期',

  'pages.other-fee.form.startDate': '开始时间',
  'pages.other-fee.form.startDatePlaceholder': '请选择开始时间',
  'pages.other-fee.form.startDateRequired': '请选择开始时间',

  'pages.other-fee.form.endDate': '结束时间',
  'pages.other-fee.form.endDatePlaceholder': '请选择结束时间',
  'pages.other-fee.form.endDateRequired': '请选择结束时间',

  'pages.other-fee.form.buildingId': '楼栋',
  'pages.other-fee.form.buildingIdPlaceholder': '请选择楼栋',
  'pages.other-fee.form.buildingIdRequired': '请选择楼栋',

  'pages.other-fee.form.floor': '楼层',
  'pages.other-fee.form.floorPlaceholder': '请选择楼层',
  'pages.other-fee.form.floorRequired': '请选择楼层',

  'pages.other-fee.form.houseId': '房屋',
  'pages.other-fee.form.houseIdPlaceholder': '请选择房屋',
  'pages.other-fee.form.houseIdRequired': '请选择房屋',

  'pages.other-fee.form.amount': '费用金额',
  'pages.other-fee.form.amountPlaceholder': '请输入费用金额',
  'pages.other-fee.form.amountRequired': '请输入费用金额',

  'pages.other-fee.form.lateFee': '滞纳金',
  'pages.other-fee.form.lateFeePlaceholder': '请输入滞纳金',

  'pages.other-fee.form.discountAmount': '优惠金额',
  'pages.other-fee.form.discountAmountPlaceholder': '请输入优惠金额',

  'pages.other-fee.form.finalAmount': '最终应付金额',
  'pages.other-fee.form.finalAmountPlaceholder': '自动计算',
  'pages.other-fee.form.finalAmountRequired': '最终金额将自动计算',

  'pages.other-fee.form.remarks': '备注',
  'pages.other-fee.form.remarksPlaceholder': '请输入备注信息',
  'pages.other-fee.form.remarksMaxLength': '备注长度不能超过500个字符',

  // 状态选项
  'pages.other-fee.status.unpaid': '未缴费',
  'pages.other-fee.status.paid': '已缴费',
  'pages.other-fee.status.overdue': '逾期',
  'pages.other-fee.status.partial': '部分缴费',
  'pages.other-fee.status.cancelled': '已取消',
  'pages.other-fee.status.draft': '草稿',
  'pages.other-fee.status.pending': '待审核',
  'pages.other-fee.status.approved': '已通过',
  'pages.other-fee.status.rejected': '已拒绝',
  'pages.other-fee.status.notified': '已通知',

  // 详情模态框
  'pages.other-fee.detail.modalTitle': '其他费用账单详情',
  'pages.other-fee.detail.basicInfo': '基本信息',
  'pages.other-fee.detail.houseOwnerInfo': '房屋与业主信息',
  'pages.other-fee.detail.feeInfo': '金额信息',
  'pages.other-fee.detail.paymentInfo': '缴费信息',
  'pages.other-fee.detail.systemInfo': '系统信息',
  'pages.other-fee.detail.auditRecords': '审核记录',

  // 详情字段
  'pages.other-fee.detail.billNo': '账单编号',
  'pages.other-fee.detail.billName': '账单名称',
  'pages.other-fee.detail.period': '账期',
  'pages.other-fee.detail.status': '缴费状态',
  'pages.other-fee.detail.approvalStatus': '审核状态',
  'pages.other-fee.detail.houseInfo': '房屋信息',
  'pages.other-fee.detail.ownerInfo': '业主信息',
  'pages.other-fee.detail.ownerIdCard': '身份证:',
  'pages.other-fee.detail.ownerEmail': '邮箱:',
  'pages.other-fee.detail.ownerId': '业主ID:',
  'pages.other-fee.detail.amount': '费用金额',
  'pages.other-fee.detail.lateFee': '滞纳金',
  'pages.other-fee.detail.discountAmount': '优惠金额',
  'pages.other-fee.detail.finalAmount': '最终金额',
  'pages.other-fee.detail.paymentMethod': '支付方式',
  'pages.other-fee.detail.paymentReference': '支付凭证号',
  'pages.other-fee.detail.paidDate': '缴费日期',
  'pages.other-fee.detail.createdTime': '创建时间',
  'pages.other-fee.detail.updatedTime': '更新时间',
  'pages.other-fee.detail.remarks': '备注',

  // 货币单位
  'pages.other-fee.currency.yuan': '元',
  'pages.other-fee.currency.php': '₱',

  // Detail组件字段
  'pages.other-fee.detail.basicInfo': '基本信息',
  'pages.other-fee.detail.billNo': '账单编号',
  'pages.other-fee.detail.billName': '账单名称',
  'pages.other-fee.detail.period': '账期',
  'pages.other-fee.detail.paymentStatus': '缴费状态',
  'pages.other-fee.detail.approvalStatus': '审核状态',
  'pages.other-fee.detail.startDate': '开始日期',
  'pages.other-fee.detail.endDate': '结束日期',
  'pages.other-fee.detail.houseOwnerInfo': '房屋与业主信息',
  'pages.other-fee.detail.houseInfo': '房屋信息',
  'pages.other-fee.detail.ownerInfo': '业主信息',
  'pages.other-fee.detail.amountInfo': '金额信息',
  'pages.other-fee.detail.baseAmount': '基础金额',
  'pages.other-fee.detail.lateFee': '滞纳金',
  'pages.other-fee.detail.discountAmount': '优惠金额',
  'pages.other-fee.detail.finalAmount': '最终金额',
  'pages.other-fee.detail.paymentInfo': '缴费信息',
  'pages.other-fee.detail.paymentMethod': '支付方式',
  'pages.other-fee.detail.paymentReference': '支付凭证号',
  'pages.other-fee.detail.dueDate': '到期日期',
  'pages.other-fee.detail.paymentDate': '缴费日期',
  'pages.other-fee.detail.systemInfo': '系统信息',
  'pages.other-fee.detail.createdTime': '创建时间',
  'pages.other-fee.detail.updatedTime': '更新时间',
  'pages.other-fee.detail.remarks': '备注',

  // 消息提示
  'pages.other-fee.message.selectRecordsToDelete': '请选择要删除的记录',
  'pages.other-fee.message.selectRecordsToAudit': '请选择要提交审核的账单',
  'pages.other-fee.message.deleteSuccess': '删除成功',
  'pages.other-fee.message.deleteFailed': '删除失败',
  'pages.other-fee.message.auditSubmitSuccess': '提交审核成功',
  'pages.other-fee.message.auditSubmitFailed': '提交审核失败',
  'pages.other-fee.message.updateSuccess': '更新成功',
  'pages.other-fee.message.createSuccess': '创建成功',
  'pages.other-fee.message.submitFailed': '提交失败',
  'pages.other-fee.message.batchDeleteSuccess': '批量删除成功',
  'pages.other-fee.message.batchDeleteFailed': '批量删除失败',

  // 分页相关
  'pages.other-fee.pagination.showTotal': '第 {range0}-{range1} 条/总共 {total} 条',

  // 加载状态
  'pages.other-fee.loading.auditRecords': '加载中...',
  'pages.other-fee.empty.auditRecords': '暂无审核记录',

  // 错误日志
  'pages.other-fee.error.loadRecentMonths': '加载最近6个月时间列表失败:',
  'pages.other-fee.error.loadTreeData': '加载楼栋楼层房屋数据失败:',
  'pages.other-fee.error.loadTableData': '获取其他费用账单列表失败:',
  'pages.other-fee.error.loadStatusOptions': '加载状态字典失败:',
  'pages.other-fee.error.loadApprovalStatusOptions': '加载审核状态字典失败:',
  'pages.other-fee.error.loadBuildings': '加载楼栋列表失败:',
  'pages.other-fee.error.loadFloors': '加载楼层列表失败:',
  'pages.other-fee.error.loadHouses': '加载房屋列表失败:',
  'pages.other-fee.error.generateOrderNo': '生成订单号失败:',
  'pages.other-fee.error.getAuditRecords': '获取审核记录失败:',

  // Popconfirm 相关
  'pages.other-fee.popconfirm.deleteTitle': '确定要删除这条记录吗？',
  'pages.other-fee.popconfirm.okText': '确定',
  'pages.other-fee.popconfirm.cancelText': '取消',
};
